import gql from 'graphql-tag';

const basicVarDeclarations = `
  $key: String!
  $name: String!
  $groupId: uuid
  $projectId: uuid
`;

const varSetters = `
  key: $key
  name: $name
  groupId: $groupId
  projectId: $projectId
`;

export const createDeviceMutation = gql`
  mutation(
    ${basicVarDeclarations}
  ) {
    insert_device(
      objects: {
        ${varSetters}
      }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const updateDeviceMutation = gql`
  mutation(
    $id: uuid!
    ${basicVarDeclarations}
  ) {
    update_device(
      where: { id: { _eq: $id} }
      _set: {
        ${varSetters}
      }
    ) {
      affected_rows
    }
  }
`;
